jQuery( function() {
    showPopupShippingRates();
    showPopupProductFilter();
    showPopupFilterSort();
    showPopupFreeSample();
    showPopupFreeSampleAfterAddCart();
    popupFreebiesCart();
    initKlaviyoHandlers();
    privacyCookieModal();
    showMapPage();
} );

/* modal map page */
function showMapPage() {
    const mapPopUp = $('#popup-map');
    $(document).on('change', '.popup-alert .gfield_radio div input', function (event) {
        if($('.popup-alert .gfield_radio div:nth-of-type(2) input').is(':checked')){
            mapPopUp.addClass('show');
            $('.popup-alert .gfield_radio div:nth-of-type(2)').css({
                'color':'red'
            })
            $('.site-main input.gform_button.button').prop('disabled', true)

        } else {
            mapPopUp.removeClass('show');
             $('.popup-alert .gfield_radio div:nth-of-type(2)').css({
                'color':'#4A4A4A'
            })
            $('.site-main input.gform_button.button').prop('disabled', false)
        }
    });

    $('.popup-close').on('click', function (e) {
        e.preventDefault();
        mapPopUp.removeClass('show');
    });
}

/* modal Shipping Rates */
function showPopupShippingRates() {
    const rates = $('#shipping-rates');

    $('body').on('click', '.tooltip-info', function () {
        rates.addClass('show');
    });
    $('.popup-close').on('click', function (e) {
        e.preventDefault();
        rates.removeClass('show');
    });
}

/* modal category_product_filter */
function showPopupProductFilter() {
    const prodFilter = $('#category_product_filter');
    $('.category-select-inner').on('click', function () {
        prodFilter.addClass('show');
    });
    $('.popup-close').on('click', function (e) {
        e.preventDefault();
        prodFilter.removeClass('show');
    });
}

/* modal filter and sort category*/
function showPopupFilterSort() {
    const filterSort = $('#category_product_sorting');
    $('#btn-filter-sort').on('click', function () {
        filterSort.addClass('show');
    });
    $('.popup-close').on('click', function (e) {
        e.preventDefault();
        filterSort.removeClass('show');
    });
}

/* modal free-sample */
function showPopupFreeSample() {
    const sample = $('#popup-free-sample');
    $('body').on('click', '#button-free-sample', function () {
        let samples = $('input[name="samples"]:checked').val();
        const form = $('form.form-giveaway');

        if ('undefined' === typeof samples) {
            alert('Please choose one of sample product');
            return;
        }
        form.data('product_id', samples);

        givewayAddProductToCart( samples );


        sample.addClass('show');
    });

    $('.popup-close').on('click', function (e) {
        e.preventDefault();
        sample.removeClass('show');
    });
}

function givewayAddProductToCart(samples) {
    const data = {
        action: 'kingpalm_giveaway_add_to_cart',
        product_id: samples,
    }

    $.ajax({
        url: kingpalm_ajax.url,
        dataType: "json",
        type: "post",
        data: data,
        success: function (msg) {
        },
        error: function () {
        }
    });
}
function showPopupFreeSampleAfterAddCart() {
    const sample = $('#popup-free-sample');
    $('body').on('click', '.giveaway .button-add-to-cart-giveaway', function () {
        const form = $('form.form-giveaway');
        const product_id = $(this).data('product_id');
        form.data('product_id', product_id);
        givewayAddProductToCart( product_id );
        sample.addClass('show');
    });

    $('.popup-close').on('click', function (e) {
        e.preventDefault();
        sample.removeClass('show');
    });
}

function popupFreebiesCart() {
    const freebies = $('#popup-freebies-cart');
    $(document).on('click', function(e) {
        const isCloseBtn = $(e.target).hasClass('popup-close') && $(e.target).closest("#popup-freebies-cart").length !== 0;
        const isPopupContent = $(e.target).closest("#popup-freebies-cart .content").length !== 0;
        if (!isPopupContent || isCloseBtn) {
            if( freebies.length ) {
                freebies.removeClass('show');
                if( isCloseBtn ) {
                    window.location.href = '/checkout/';
                }
            }
        }
    });
}

function initKlaviyoHandlers() {
    $( 'body' ).on('click', '.klaviyo-form-RUPpWF button', function () {
        localStorage.setItem( 'giveawayEmail', $('.klaviyo-form-RUPpWF').find('input[name="email"]').val() );
        localStorage.setItem( 'giveawayPhone', $('.klaviyo-form-RUPpWF').find('input[name="phone-number"]').val() );
    });

    $( 'body' ).on('click', 'a.ql-font-palatino-linotype', function (e) {
        e.preventDefault();
        let checkoutHref = '/checkout/';
        let checkoutHrefParts = [];
        let giveawayEmail = localStorage.getItem( 'giveawayEmail' );
        let giveawayPhone = localStorage.getItem( 'giveawayPhone' );
        if( giveawayEmail != null && giveawayEmail != '' && giveawayEmail != undefined ) {
            checkoutHrefParts.push('billing_email='+giveawayEmail);
        }
        if( giveawayPhone != null && giveawayPhone != '' && giveawayPhone != undefined ) {
            checkoutHrefParts.push('shipping_phone='+giveawayPhone);
        }
        if(checkoutHrefParts.length) {
            checkoutHrefParts = checkoutHrefParts.join('&');
            checkoutHref = '/checkout/?' + checkoutHrefParts
        }
        window.location.href = checkoutHref;
    });
}

/* popup cookie */
function privacyCookieModal() {
    setTimeout(() => {
        // console.log(readCookie('viewed-kp-cookie-policy'))
        if (readCookie('viewed-kp-cookie-policy') === null) {
            jQuery('.cookie-policy-modal').show();
        }

        jQuery('.cookie-policy-agree').on('click', function (e) {
            e.preventDefault();

            if (navigator.cookieEnabled) {
                createCookie('viewed-kp-cookie-policy', 'yes', 365);
                jQuery(this).closest('.cookie-policy-modal').fadeOut('slow');

            } else {
                jQuery(this).closest('.cookie-policy-modal').find('.modal-body p').html('\
                    <span class="error">\
                    Dang, that didn\'t work.  You\'ll need to allow cookies \
                    in your browser settings before we log you on..\
                    </span>');
                return false;
            }
        })
    }, 4000);
}

function createCookie(name, value, days) {
    var expires;

    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
    } else {
        expires = "";
    }
    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
}

function readCookie(name) {
    var nameEQ = encodeURIComponent(name) + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ')
            c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0)
            return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
}

function eraseCookie(name) {
    createCookie(name, "", -1);
}

/* end popup cookie */
